<div class="modal-btns">
  <obc-botao-fechar
    class="modal-btns__botao-fechar"
    (btnFechar)="fecharModal()"
    *ngIf="data.isBtnFechar"
  ></obc-botao-fechar>
  <span class="modal-btns__icone-atencao"></span>
  <div class="modal-btns__info">
    <h2 class="modal-btns__subtitulo">{{ data.titulo }}</h2>
    <p class="modal-btns__mensagem" [innerHtml]="data.mensagem"></p>
  </div>
</div>
<div class="footer">
  <button class="footer__botao-primario" (click)="confirmarModal()">{{ data.textoBtnPrimario }}</button>
</div>
